import { createHashRouter, redirect } from 'react-router-dom';
import { ErrorBoundary } from 'src/modules/common/components/ErrorBoundary/ErrorBoundary';
import { HomePage } from 'src/actuators/home/HomePage.tsx';
import { BELIMO_HASH_PREFIX } from 'src/BELIMO_HASH_PREFIX.ts';
import { ActuatorsListPage } from 'src/actuators/list/ActuatorsListPage.tsx';
import { ActuatorAccessoriesPage } from 'src/actuators/accessories/ActuatorAccessoriesPage.tsx';
import { PrefetchUserInput } from 'src/actuators/user-input/PrefetchUserInput.tsx';
import { PrefetchActuatorCheckout } from 'src/actuators/checkout/PrefetchActuatorCheckout.tsx';

export enum PATHS {
    Home = `${BELIMO_HASH_PREFIX}/`,
    UserInput = `${BELIMO_HASH_PREFIX}/user-input`,
    Actuators = `${BELIMO_HASH_PREFIX}/actuators`,
    ActuatorsFilter = `${BELIMO_HASH_PREFIX}/actuators-filter`,
    Accessories = `${BELIMO_HASH_PREFIX}/accessories`,
    Checkout = `${BELIMO_HASH_PREFIX}/checkout`,
}

const errorElement = <ErrorBoundary/>;

export const router = () => createHashRouter([
    {
        path: '/',
        loader: () => redirect(PATHS.Home),
    },
    {
        path: PATHS.Home,
        element: <HomePage/>,
        errorElement,
    },
    {
        path: PATHS.UserInput,
        element: <PrefetchUserInput/>,
        errorElement,
    },
    {
        path: `${PATHS.Actuators}/:page`,
        element: <ActuatorsListPage/>,
        errorElement,
    },
    {
        path: `${PATHS.Accessories}/:actuatorLabel/:page`,
        element: <ActuatorAccessoriesPage/>,
        errorElement,
    },
    {
        path: `${PATHS.Checkout}/:actuatorLabel/:page`,
        element: <PrefetchActuatorCheckout/>,
        errorElement,
    },
    {
        path: '*',
        element: <HomePage/>,
        errorElement,
    },
]);
